import React from "react";

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "40px",
};

const thStyle = {
    width: "33.33%",
    border: "1px solid #555",
    padding: "10px",
    backgroundColor: "#2a2a2a",
    color: "#fff",
    textAlign: "center",
};

const tdStyle = {
    border: "1px solid #444",
    padding: "10px",
    color: "#ddd",
    verticalAlign: "top",
    backgroundColor: "#1a1a1a",
};

const containerStyle = {
    color: "#ddd",
    fontFamily: "Arial, sans-serif",
    padding: "24px",
};

const PathologyClassificationExactDark = () => {
    return (
        <div style={containerStyle}>
            {/* === AAB Table === */}
            <table style={tableStyle}>
                <thead>
                <tr>
                    <th style={thStyle}>Current WHO Terminology</th>
                    <th style={thStyle}>Tabar Proposed Terminology: Acinar Adenocarcinoma of the Breast AAB Uni- or Multifocal Distribution</th>
                    <th style={thStyle}>BIRADS Options</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td style={tdStyle}>Ductal carcinoma in situ, grade 1</td>
                    <td style={tdStyle}>Carcinoma in situ, AAB, grade 1</td>
                    <td style={tdStyle}><b>Calcifications:</b> Amorphous</td>
                </tr>
                <tr>
                    <td style={tdStyle}>Ductal carcinoma in situ, grade 2</td>
                    <td style={tdStyle}>Carcinoma in situ, AAB, grade 2</td>
                    <td style={tdStyle}><b>Calcifications</b>: Coarse Heterogeneous, Fine Pleomorphic</td>
                </tr>
                <tr>
                    <td style={tdStyle}>
                        Invasive (ductal) carcinoma:<br/>
                        • No special type,<br/>
                        • Well or moderately differentiated.
                    </td>
                    <td style={tdStyle}>
                        Invasive AAB:<br/>
                        • No special type,<br/>
                        • Well or moderately differentiated.
                    </td>
                    <td style={tdStyle}><b>Mass Margin:</b> Spiculated</td>
                </tr>
                <tr>
                    <td style={tdStyle}>Tubular carcinoma</td>
                    <td style={tdStyle}>Invasive AAB, tubular type</td>
                    <td style={tdStyle}><b>Mass Margin:</b> Spiculated</td>
                </tr>
                <tr>
                    <td style={tdStyle}>Invasive micropapillary carcinoma</td>
                    <td style={tdStyle}>Invasive AAB, micropapillary type</td>
                    <td style={tdStyle}><b>Mass Margin:</b> Spiculated</td>
                </tr>
                <tr>
                    <td style={tdStyle}>
                        Invasive (ductal) carcinoma:<br/>
                        • No special type,<br/>
                        • Poorly differentiated.
                    </td>
                    <td style={tdStyle}>
                        Invasive AAB:<br/>
                        • No special type,<br/>
                        • Poorly differentiated.
                    </td>
                    <td style={tdStyle}>
                        <b>Mass Shape:</b> Round Oval Irregular<br/>
                        <b>Mass Margin:</b> Circumscribed, Indistinct, Microlobulated
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>
                        Invasive (ductal) carcinoma:<br/>
                        • Poorly differentiated,<br/>
                        • Triple negative, basal cell type.
                    </td>
                    <td style={tdStyle}>
                        Invasive AAB:<br/>
                        • Poorly differentiated,<br/>
                        • Triple negative, basal cell type.
                    </td>
                    <td style={tdStyle}>
                        <b>Mass Shape:</b> Round Oval Irregular<br/>
                        <b>Mass Margin:</b> Circumscribed, Indistinct, Microlobulated
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Mucinous carcinoma</td>
                    <td style={tdStyle}>Invasive AAB, mucinous type</td>
                    <td style={tdStyle}>
                        <b>Mass Shape:</b> Round Oval, Irregular<br/>
                        <b>Mass Margin:</b> Circumscribed, Indistinct, Microlobulated
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Invasive lobular carcinoma (solid type)</td>
                    <td style={tdStyle}>Invasive AAB, solid lobular type</td>
                    <td style={tdStyle}>
                        <b>Mass Shape:</b> Round Oval, Irregular<br/>
                        <b>Mass Margin:</b> Circumscribed, Indistinct, Microlobulated
                    </td>
                </tr>
                </tbody>
            </table>

            {/* === DAB Table === */}
            <table style={tableStyle}>
                <thead>
                <tr>
                    <th style={thStyle}>Current WHO Terminology</th>
                    <th style={thStyle}>Tabar Proposed Terminology: Ductal Adenocarcinoma of the Breast DAB Diffuse of Lobar Distribution</th>
                    <th style={thStyle}>BIRADS Options</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td style={tdStyle}>
                        Ductal carcinoma in situ, grade 1-3 +/- microinvasion:<br/>
                        • With any combination of pattern (solid, micropapillary, cribriform),<br/>
                        • With necrosis or fluid production,<br/>
                        • With microcalcifications
                    </td>
                    <td style={tdStyle}>
                        Ductal adenocarcinoma of the breast, DAB:<br/>
                        • With necrosis or fluid and microcalcifications,<br/>
                        • Neoductgenesis recognised by ‘radiologic imaging biomarkers’.
                    </td>
                    <td style={tdStyle}>
                        <b>Calcifications:</b> <br/>
                        Fine Linear +/- Branching<br/>
                        +/- Architectural Distortion
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>
                        Ductal carcinoma in situ, grade 1-3 +/- microinvasion:<br/>
                        • Predominantly micropapillary pattern<br/>
                        • With necrosis or fluid production,<br/>
                        • Without microcalcifications.
                    </td>
                    <td style={tdStyle}>
                        Ductal adenocarcinoma of the breast, DAB:<br/>
                        • With fluid,<br/>
                        • Without microcalcifications,<br/>
                        • Neoductgenesis. Recognised by ‘radiologic imaging biomarkers’.
                    </td>
                    <td style={tdStyle}>No Finding on Mammogram</td>
                </tr>
                <tr>
                    <td style={tdStyle}>
                        Ductal carcinoma in situ, grade 2–3 +/- microinvasion:<br/>
                        • With any combination of pattern (solid, micropapillary, cribriform),<br/>
                        • With necrosis or fluid production,<br/>
                        • Without microcalcifications,<br/>
                        • With architectural disturbance.
                    </td>
                    <td style={tdStyle}>
                        Ductal adenocarcinoma of the breast, DAB:<br/>
                        • With necrosis or fluid,<br/>
                        • Without microcalcifications,<br/>
                        • Neoductgenesis. Recognised by ‘radiologic imaging biomarkers’.
                    </td>
                    <td style={tdStyle}>Architectural Distortion</td>
                </tr>
                </tbody>
            </table>

            {/* === BCMO Table === */}
            <table style={tableStyle}>
                <thead>
                <tr>
                    <th style={thStyle}>Current WHO Terminology</th>
                    <th style={thStyle}>Tabar Proposed Terminology: Breast Cancer of apparent Mesenchymal Origin BCMO Uni- or Multifocal or Diffuse Distribution</th>
                    <th style={thStyle}>BIRADS Options</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td style={tdStyle}>Infiltrating Lobular Carcinoma</td>
                    <td style={tdStyle}>Breast Cancer of apparent Mesenchymal Origin (BCMO)</td>
                    <td style={tdStyle}>Architectural Distortion</td>
                </tr>
                </tbody>
            </table>
            <h2 style={{fontSize: "20px", marginBottom: "10px", color: "#fff"}}>References</h2>
            <ul style={{paddingLeft: "20px", lineHeight: "1.8"}}>
                <li>Tan PH, Ellis I, Allison K, et al. WHO Classification of Tumours Editorial Board. The 2019 World Health Organization classification of tumours of the breast.
                    Histopathology. 2020 Aug;77(2):181-185. doi: 10.1111/his.14091. Epub 2020 Jul 29. PMID: 32056259.
                </li>
                <li>Lakhani SR, Ellis IO, Schnitt SJ, Tan PH, van de Vijver M. eds. World Health Organization Classification of Tumours of the Breast. 4th ed. Lyon: IARC Press, 2012.</li>
                <li>Tabár L, Dean PB, Lee Tucker F, et al. A new approach to breast cancer terminology based on the anatomic site of tumour origin: The importance of radiologic imaging biomarkers. Eur
                    J Radiol. 2022 Apr;149:110189. doi: 10.1016/j.ejrad.2022.110189. Epub 2022 Feb 9. PMID: 35151954.
                </li>
                <li>Tabár L, Dean PB, Tucker FL, et al. Breast cancers originating from the terminal ductal lobular units: In situ and invasive acinar adenocarcinoma of the breast, AAB.
                    Eur J Radiol. 2022 Jul;152:110323. doi: 10.1016/j.ejrad.2022.110323. Epub 2022 May 10. PMID: 35576721.
                </li>
                <li>Tabár L, Dean PB, Lee Tucker F, et al. Breast cancers originating from the major lactiferous ducts and the process of neoductgenesis: Ductal Adenocarcinoma of the Breast, DAB. Eur
                    J Radiol. 2022 Aug;153:110363. doi: 10.1016/j.ejrad.2022.110363. Epub 2022 May 18. PMID: 35605334.
                </li>
            </ul>
        </div>
    );
};

export default PathologyClassificationExactDark;
